/* eslint-disable */

/**
 * Dependencies:
 * - Custom select component
 *
 * Required translation strings:
 * - addToCart
 * - noStock
 * - noVariant
 * - onlyXLeft
 */

if (!customElements.get("variant-picker")) {
  let currentVariant = "";
  class VariantPicker extends HTMLElement {
    constructor() {
      super();
      this.section = this.closest(".js-product");
      this.productForm = this.section?.querySelector(".js-product-form-main");
      this.optionSelectors = this.querySelectorAll(".option-selector");
      this.data = this.getProductData();

      this.updateAvailability();
      this.addEventListener("change", this.handleVariantChange.bind(this));
      const onRecurringChange = (e) => {
        if (!e.target || !e.target.closest) return;
        const optionSection = e.target.closest(".js-product");
        if (optionSection !== this.section) return;
        this.onRecurringOptionChange();
      };
      document.addEventListener("recurring-option:change", onRecurringChange);
      currentVariant = this.data.product.variants[0].id;

      this.variant = this.data.product.variants.find(
        (v) => v.id === currentVariant
      );

      window.history.replaceState(
        {},
        "",
        `${this.dataset.url}?variant=${this.variant.id}`
      );

      if (this.hasSubscriptionActive()) {
        const secondaryBtn = document.querySelector(
          '.navigation-vrac__content [name="add"]'
        );
        if (secondaryBtn) {
          const priceEl = secondaryBtn.querySelector(".price__current");
          if (priceEl) priceEl.classList.remove("price__current");
          this.updateAddToCartButton();
        }
      }

      // Apply initial prices (fixes drawer showing wrong price on first load)
      this.updatePrice();
      // In quick-add drawer, the form (add-to-cart button with price) is injected after our constructor.
      // Listen for the drawer's form-ready event so we can update the button price to one-time.
      const drawer = this.section?.closest('quick-add-drawer');
      if (drawer) {
        const refreshPrices = () => {
          this.prices = null;
          this.updatePrice();
        };
        let fallbackTimeout;
        const onFormReady = () => {
          refreshPrices();
          drawer.removeEventListener('quick-add:form-ready', onFormReady);
          if (fallbackTimeout) clearTimeout(fallbackTimeout);
        };
        drawer.addEventListener('quick-add:form-ready', onFormReady);
        // Fallback if quick-add.js doesn't dispatch the event (e.g. not yet deployed)
        fallbackTimeout = setTimeout(() => {
          fallbackTimeout = null;
          drawer.removeEventListener('quick-add:form-ready', onFormReady);
          refreshPrices();
        }, 150);
      }

      // Override default variant if metafield custom.default_variant is set
      const defaultVariantId = parseInt(this.dataset.defaultVariantId);
      if (defaultVariantId) {
        const defaultVariant = this.data.product.variants.find(
          (v) => v.id === defaultVariantId
        );
        if (defaultVariant && defaultVariant.available) {
          this.optionSelectors.forEach((selector, index) => {
            const optionValue = defaultVariant.options[index];
            if (selector.dataset.selectorType === "dropdown") {
              const option = selector.querySelector(
                "custom-select"
              );
              if (option) {
                const item = Array.from(
                  option.querySelectorAll(".custom-select__option")
                ).find((el) => el.dataset.value === optionValue);
                if (item) item.click();
              }
            } else {
              const input = Array.from(
                selector.querySelectorAll("input")
              ).find((inp) => inp.value === optionValue);
              if (input) input.checked = true;
            }
          });
          this.handleVariantChange();
        }
      }
    }

    connectedCallback() {
      if (document.querySelector(".product-variant__switsh-item")) {
        document
          .querySelectorAll(".product-variant__switsh-item")
          .forEach((elem) => {
            elem.addEventListener("click", (evt) => {
              document
                .querySelectorAll(".product-variant__switsh-item")
                .forEach((elem) => {
                  elem.classList.remove("active");
                });
              evt.target.classList.add("active");
              let label = evt.target.getAttribute("data-current-label");

              document.querySelectorAll(".label-custom").forEach((elem) => {
                elem.classList.add("hidden");

                if (elem.classList.contains(`${label}--label-custom`)) {
                  elem.classList.remove("hidden");
                }
              });

              document
                .querySelector(
                  `input:not(.is-unavailable) + .${label}--label-custom`
                )
                .click();
            });
          });
      }

      if (document.querySelector(".product-form__blends-flavors")) {
        document
          .querySelectorAll(".product-form__blends-flavors .form-subscription__flavor-btn")
          .forEach((button) => {
            button.addEventListener("click", (evt) => {
              evt.preventDefault();
              const target = evt.currentTarget;
              const targetOption = target.getAttribute("data-target-option");
              if (!targetOption) return;

              const sectionRoot = target.closest(".js-product") || document;
              const variantPicker = sectionRoot.querySelector("variant-picker");
              if (!variantPicker) return;

              sectionRoot
                .querySelectorAll(
                  ".product-form__blends-flavors .form-subscription__flavor-btn"
                )
                .forEach((btn) => {
                  btn.classList.remove("form-subscription__flavor-btn--active");
                });
              target.classList.add("form-subscription__flavor-btn--active");

              const currentLabel = target.getAttribute("data-current-label");
              if (currentLabel) {
                sectionRoot.querySelectorAll(".label-custom").forEach((elem) => {
                  elem.classList.add("hidden");
                  if (elem.classList.contains(`${currentLabel}--label-custom`)) {
                    elem.classList.remove("hidden");
                  }
                });

                const candidate = variantPicker.querySelector(
                  `input:not(.is-unavailable) + .${currentLabel}--label-custom`
                );
                if (candidate) {
                  candidate.click();
                  return;
                }
              }

              const options = Array.from(
                variantPicker.querySelectorAll(".option-selector .js-option")
              );
              const selected = options.find(
                (opt) => opt.value === targetOption && !opt.classList.contains("is-unavailable")
              );
              const fallback = options.find((opt) => opt.value === targetOption);
              const inputToSelect = selected || fallback;
              if (!inputToSelect) return;

              inputToSelect.checked = true;
              inputToSelect.dispatchEvent(new Event("change", { bubbles: true }));
            });
          });
      }
    }

    /**
     * Handles 'change' events on the variant picker element.
     * @param {object} evt - Event object.
     */
    handleVariantChange(evt) {
      const selectedOptions = this.getSelectedOptions();
      this.variant = null;

      this.product_tempalte = false;
      if (evt?.target.closest("product-template")) {
        this.product_tempalte = true;
      }

      this.switsh_image_quick = false;

      if (
        evt?.target.closest(".drawer__content") &&
        evt?.target.getAttribute("name") == "-couleur-option"
      ) {
        this.switsh_image_quick = true;
        let image_id = evt.target.getAttribute("id");
        this.image_src = document
          .querySelector(
            '.drawer__content .opt-label--swatch[for="' + image_id + '"] img'
          )
          .getAttribute("src");
      }

      // Get selected variant data (if variant exists).
      this.variant = this.data.product.variants.find((v) =>
        v.options.every((val, index) => val === selectedOptions[index])
      );

      if (this.variant) {
        this.updateMedia();
        this.updateUrl(evt);
        this.updateVariantInput();
      }

      this.updateAddToCartButton();
      this.updateAvailability();
      this.updatePrice();
      this.updateBackorderText();
      this.updatePickupAvailability();
      this.updateSku();
      VariantPicker.updateLabelText(evt);

      this.dispatchEvent(
        new CustomEvent("on:variant:change", {
          bubbles: true,
          detail: {
            form: this.productForm,
            variant: this.variant,
            product: this.data.product,
          },
        })
      );
    }

    /**
     * Called when the user toggles subscription vs one-time (recurring-option:change).
     * Refreshes displayed prices and add-to-cart button without changing variant.
     */
    onRecurringOptionChange() {
      if (this.variant) {
        this.updatePrice();
        this.updateAddToCartButton();
      }
    }

    /**
     * Updates the "Add to Cart" button label and disabled state.
     */
    updateAddToCartButton() {
      this.productForm = this.section.querySelector(".js-product-form-main");
      if (!this.productForm) return;

      // Re-query button each time (handles drawer re-renders) intelligems: bb
      this.addBtn = this.productForm.querySelector('[name="add"]') ||
        this.closest('quick-add-drawer')?.querySelector('[name="add"]');

      if (!this.addBtn) return;

      const variantAvailable = this.variant && this.variant.available;
      const unavailableStr = this.variant
        ? theme.strings.noStock
        : theme.strings.noVariant;


      if (this.variant) {
        this.updateMainAddButton(variantAvailable, unavailableStr);
        this.updateSecondaryAddButton(variantAvailable);
      }
    }

    updateMainAddButton(variantAvailable, unavailableStr) {
      this.addBtn.disabled = !variantAvailable;

      if (variantAvailable) {
        const pricing = this.calculateButtonPricing();

        if (this.hasSubscriptionActive()) {
          this.addBtn.innerHTML = this.formatSubscriptionButtonContent(pricing);
        } else {
          this.addBtn.innerHTML = this.formatButtonText(pricing);
        }
      } else {
        this.addBtn.textContent = unavailableStr;
      }
    }

    updateSecondaryAddButton(variantAvailable) {
      const secondaryBtn = document.querySelector(
        '.navigation-vrac__content [name="add"]'
      );
      if (!secondaryBtn) return;

      this.addBtn2 = this.addBtn2 || secondaryBtn;
      this.addBtn2.disabled = !variantAvailable;

      if (variantAvailable) {
        const pricing = this.calculateButtonPricing();
        if (this.hasSubscriptionActive()) {
          this.addBtn2.innerHTML =
            this.formatSubscriptionButtonContent(pricing);
        } else {
          this.addBtn2.innerHTML = this.formatButtonText(pricing);
        }
      }
    }

    calculateButtonPricing() {
      const quantity = Number(
        document.querySelector(".qty-input__input").value
      );
      const hasSubscription = this.hasSubscriptionActive();
      const hasActiveOption = document.querySelector(
        ".product-option__container.actif"
      );
      const optionPrice = hasActiveOption
        ? Number(
            document.querySelector("[data-option-price]").dataset.optionPrice /
              100
          )
        : 0;

      let basePrice;
      if (hasSubscription) {
        const subCents = this.getSubscriptionDisplayPriceCents();
        basePrice = subCents != null ? subCents / 100 : this.variant.price / 100;
      } else {
        basePrice = this.variant.price / 100;
      }

      const totalPrice = basePrice * quantity + optionPrice;

      return {
        hasSubscription,
        hasActiveOption,
        basePrice,
        optionPrice,
        totalPrice,
        quantity,
        originalPrice: this.variant.compare_at_price
          ? this.variant.compare_at_price / 100
          : this.variant.price / 100,
      };
    }

    hasSubscriptionActive() {
      const subscribeElement = document.querySelector(
        '[data-subscribe="true"]'
      );
      return (
        subscribeElement &&
        subscribeElement.classList.contains("actif") &&
        !document.querySelector(".product-pack__recurring-options.hidden-force")
      );
    }

    /**
     * First-order display price in cents when subscription is selected.
     * Discount is applied to the one-time purchase price (variant.price), not the subscription price.
     * first_order_discount_amount (euros) prevails over first_order_discount_percentage when > 0.
     * @returns {number|undefined} Cents, or undefined if no subscription allocation.
     */
    getSubscriptionDisplayPriceCents() {
      if (
        !this.variant?.selling_plan_allocations?.length
      ) {
        return undefined;
      }
      const oneTimePriceCents = this.variant.price;
      const amount = Number(this.data.first_order_discount_amount) || 0;
      const percent = Number(this.data.first_order_discount_percentage) || 0;
      if (amount > 0) {
        const discountCents = Math.round(amount * 100);
        return Math.max(0, oneTimePriceCents - discountCents);
      }
      if (percent > 0) {
        return Math.round(
          oneTimePriceCents * (1 - percent / 100)
        );
      }
      return oneTimePriceCents;
    }

    formatButtonText(pricing) {
      const baseText = this.addBtn.dataset.addToCartText;
      return `${baseText} - <span class="money price__current" data-variant-id="${
        this.variant.id
      }">€${pricing.totalPrice.toFixed(2)}</span>
      ${
        pricing.originalPrice && pricing.totalPrice != pricing.originalPrice
          ? `<s class="price__was" data-variant-id="${
              this.variant.id
            }">€${pricing.originalPrice.toFixed(2)}</s>`
          : ""
      }`;
    }

    formatSubscriptionButtonContent(pricing) {
      const baseText = this.addBtn.dataset.addToCartText;

      if (pricing.hasActiveOption) {
        return this.formatButtonText(pricing);
      } else {
        return `${baseText} - <span class='price__current'>€${pricing.totalPrice.toFixed(
          2
        )}</span><s class="price__was" data-variant-id="${
          this.variant.id
        }">€${pricing.originalPrice.toFixed(2)}</s>`;
      }
    }

    /**
     * Updates the availability status in option selectors.
     */
    updateAvailability() {
      if (this.dataset.showAvailability === "false") return;
      let currVariant = this.variant;

      if (!this.variant) {
        currVariant = { options: this.getSelectedOptions() };
      }

      if (document.querySelector(".pack-builder")) {
        currentVariant = this.data.product.variants.find((v) =>
          v.options.every((val, index) => val === currVariant.options[index])
        ).id;

        let packBuilderInfos = document.querySelector(".pack-builder__infos");

        if (packBuilderInfos) {
          packBuilderInfos.dataset.productVariantId = currentVariant;
          packBuilderInfos.dataset.productName =
            this.data.product.variants.find((v) =>
              v.options.every(
                (val, index) => val === currVariant.options[index]
              )
            ).title;
          packBuilderInfos.dataset.sachetsTimes = document.querySelector(
            ".format_fieldset input:checked"
          ).dataset.variantMaxItems;
          packBuilderInfos.dataset.sachetsNumber = document.querySelector(
            ".format_fieldset input:checked"
          ).dataset.variantSachetsNumber;
        }

        let variants = this.data.product.variants;

        for (let variant in variants) {
          if (variants[variant].title.includes(currVariant.options[1])) {
            let inputId = document.querySelector(
              '.option-selector__btns input[value="' +
                variants[variant].options[0] +
                '"]'
            ).id;
            let inputLabel = document.querySelector(
              '.option-selector__btns label[for="' + inputId + '"]'
            );
            if (inputLabel.querySelector(".price__current") !== null) {
              inputLabel.querySelector(".price__current").innerHTML =
                Shopify.formatMoney(
                  variants[variant].price,
                  Shopify.money_format
                );
              inputLabel.querySelector(".price__current").dataset.variantId =
                variants[variant].id;
            }
          }
        }
      }

      if (
        document.querySelector(".vrac-product") &&
        this.product_tempalte == true
      ) {
        if (currVariant.available != undefined) {
          if (currVariant.available) {
            document
              .querySelector(".jc-delivery-date")
              .classList.remove("hidden");
          } else {
            document.querySelector(".jc-delivery-date").classList.add("hidden");
          }
        }
      }

      const updateOptionAvailability = (optionEl, available, soldout) => {
        const el = optionEl;
        const text = soldout ? theme.strings.noStock : theme.strings.noVariant;
        el.classList.toggle("is-unavailable", !available);

        if (optionEl.classList.contains("custom-select__option")) {
          const em = el.querySelector("em");

          if (em) {
            em.hidden = available;
          }

          if (!available) {
            if (em) {
              em.textContent = text;
            } else {
              el.innerHTML = `${el.innerHTML} <em class="pointer-events-none">${text}</em>`;
            }
          }
        } else if (!available) {
          el.nextElementSibling.title = text;
        } else {
          el.nextElementSibling.removeAttribute("title");
        }
      };

      // Flag all options as unavailable
      this.querySelectorAll(".js-option").forEach((optionEl) => {
        updateOptionAvailability(optionEl, false, false);
      });

      // Flag selector options as available or sold out, depending on the variant availability
      this.optionSelectors.forEach((selector, selectorIndex) => {
        this.data.product.variants.forEach((variant) => {
          let matchCount = 0;

          variant.options.forEach((option, optionIndex) => {
            if (
              option === currVariant.options[optionIndex] &&
              optionIndex !== selectorIndex
            ) {
              matchCount += 1;
            }
          });

          if (matchCount === currVariant.options.length - 1) {
            const options = selector.querySelectorAll(".js-option");
            const optionEl = Array.from(options).find((opt) => {
              if (selector.dataset.selectorType === "dropdown") {
                return opt.dataset.value === variant.options[selectorIndex];
              }
              return opt.value === variant.options[selectorIndex];
            });

            if (optionEl) {
              updateOptionAvailability(
                optionEl,
                variant.available,
                !variant.available
              );
            }
          }
        });
      });
    }

    /**
     * Updates the backorder text and visibility.
     */
    updateBackorderText() {
      this.backorder =
        this.backorder || this.section.querySelector(".backorder");
      if (!this.backorder) return;

      let hideBackorder = true;

      if (this.variant && this.variant.available) {
        const { inventory } = this.data.formatted[this.variant.id];

        if (this.variant.inventory_management && inventory === "none") {
          const backorderProdEl = this.backorder.querySelector(
            ".backorder__product"
          );
          const prodTitleEl = this.section.querySelector(".product-title");
          const variantTitle = this.variant.title.includes("Default")
            ? ""
            : ` - ${this.variant.title}`;

          backorderProdEl.textContent = `${prodTitleEl.textContent}${variantTitle}`;
          hideBackorder = false;
        }
      }

      this.backorder.hidden = hideBackorder;
    }

    /**
     * Updates the color option label text.
     * @param {object} evt - Event object
     */
    static updateLabelText(evt) {
      if (evt) {
        const selector = evt.target.closest(".option-selector");
        if (selector.dataset.selectorType === "dropdown") return;

        const colorText = selector.querySelector(".js-color-text");
        if (!colorText) return;

        colorText.textContent =
          evt.target.nextElementSibling.querySelector(".js-value").textContent;
      }
    }

    /**
     * Updates the product media.
     */
    updateMedia() {
      if (!this.variant.featured_media) return;


      if (this.section.matches("quick-add-drawer")) {
        this.section.updateMedia(this.variant.featured_media.id, true);
      } else {
        this.mediaGallery =
          this.mediaGallery || this.section.querySelector("media-gallery");
        if (!this.mediaGallery) return;

        const variantMedia = this.mediaGallery.querySelector(
          `[data-media-id="${this.variant.featured_media.id}"]`
        );
        this.mediaGallery.setActiveMedia(variantMedia, true, true);
      }
    }

    /**
     * Updates the pick up availability.
     */
    updatePickupAvailability() {
      this.pickUpAvailability =
        this.pickUpAvailability ||
        this.section.querySelector("pickup-availability");
      if (!this.pickUpAvailability) return;

      if (this.variant && this.variant.available) {
        this.pickUpAvailability.getAvailability(this.variant.id);
      } else {
        this.pickUpAvailability.removeAttribute("available");
        this.pickUpAvailability.innerHTML = "";
      }
    }

    /**
     * Updates the price.
     */
    updatePrice() {
      this.prices = this.section
        ? this.section.querySelectorAll(".product-info__price > .price")
        : document.querySelectorAll(".js-product .product-info__price > .price");

      // Update images if we have changable images and a variant
      const hasChangableImages = !!document.querySelector("[data-changable-image]");
      const isProductTemplate = !!document.querySelector("product-template");
      
      if (hasChangableImages && this.variant) {
        // Set product_tempalte if we're on product template
        if (isProductTemplate) {
          this.product_tempalte = true;
        }
        document.querySelectorAll("[data-changable-image]").forEach((elem) => {
          elem.classList.add("hidden");
          elem.classList.remove("full-width");
          elem.classList.remove("swiper-slide");
        });

        document
          .querySelectorAll("[data-changable-image-thumb]")
          .forEach((elem) => {
            elem.classList.add("hidden");
            elem.classList.remove("full-width-thumb");
            elem.classList.remove("swiper-slide");
          });

        // Extract parts from variant title (matching Liquid template logic)
        const variantTitle = this.variant.title;
        const titleParts = variantTitle.split('/');
        const variantFirstPart = titleParts[0]?.trim() || '';
        const variantLastPart = titleParts[titleParts.length - 1]?.trim() || '';

        // Helper function to check if image should be shown (matching Liquid logic)
        const shouldShowImage = (imageAlt) => {
          if (!imageAlt || !imageAlt.includes('/')) {
            return true; // Generic image
          }

          const imageAltParts = imageAlt.split('/');
          const imageFirstPart = imageAltParts[0]?.trim() || '';
          const imageLastPart = imageAltParts[imageAltParts.length - 1]?.trim() || '';

          if (imageFirstPart === '') {
            // Image alt starts with "/" - match against variant's last part
            return imageLastPart === variantLastPart;
          } else if (imageLastPart === '') {
            // Image alt ends with "/" - match against variant's first part
            return imageFirstPart === variantFirstPart;
          } else {
            // Image alt has both parts - match against both variant parts
            return imageFirstPart === variantFirstPart && imageLastPart === variantLastPart;
          }
        };

        let index = 0;
        let indexThumb = 0;
        let firstFullWidthSet = false;
        let firstFullWidthThumbSet = false;

        // Check each main image
        document.querySelectorAll("[data-changable-image]").forEach((elem) => {
          // Get image alt from data attribute
          const imageAlt = elem.getAttribute('data-image-alt') || '';
          
          if (shouldShowImage(imageAlt)) {
            elem.classList.remove("hidden");
            elem.classList.add("swiper-slide");
            if (!firstFullWidthSet) {
              elem.classList.add("full-width");
              firstFullWidthSet = true;
            }
            index++;
          } else {
            elem.classList.add("hidden");
            elem.classList.remove("full-width");
            elem.classList.remove("swiper-slide");
          }
        });

        // Check each thumbnail image
        document.querySelectorAll("[data-changable-image-thumb]").forEach((elem) => {
          // Get image alt from data attribute
          const imageAlt = elem.getAttribute('data-image-alt') || '';
          
          if (shouldShowImage(imageAlt)) {
            elem.classList.remove("hidden");
            elem.classList.add("swiper-slide");
            if (!firstFullWidthThumbSet) {
              elem.classList.add("full-width-thumb");
              firstFullWidthThumbSet = true;
            }
            elem.classList.add("show");
            indexThumb++;
          } else {
            elem.classList.add("hidden");
            elem.classList.remove("full-width-thumb");
            elem.classList.remove("swiper-slide");
            elem.classList.remove("show");
          }
        });

        if (window.innerWidth < 769) {
          document.querySelector("product-media").updateSwiper();
        }
      }

      if (this.product_tempalte == false && this.switsh_image_quick == true) {
        document
          .querySelector(".drawer__content .quick-add-info__media img")
          .setAttribute("src", this.image_src);
        //  change image in quick add drawer
        document
          .querySelector(".drawer__content .quick-add-info__media img")
          .setAttribute("srcset", this.image_src);
      }

      this.prices.forEach((price) => {
        if (!price) return;

        if (this.variant) {

          const priceCurrentEl = price.querySelector(".price__current, .price__current2");
          const priceWasEl = price.querySelector(".price__was");
          const unitPriceEl = price.querySelector(".unit-price");

          const isQuickAddDrawer = this.section?.closest('quick-add-drawer');
          const subscriptionActiveForMain = !isQuickAddDrawer &&
            this.hasSubscriptionActive() &&
            this.variant.selling_plan_allocations &&
            this.variant.selling_plan_allocations[0];
          const isInsideOneTimeOption = price.closest('[data-subscribe="false"]');
          const useSubscriptionPrice = !isInsideOneTimeOption && subscriptionActiveForMain;

          const subscriptionPriceFormatted = useSubscriptionPrice &&
            (() => {
              const subCents = this.getSubscriptionDisplayPriceCents();
              const subPrice = subCents != null ? subCents / 100 : this.variant.selling_plan_allocations[0].price / 100;
              return typeof Shopify !== "undefined" && Shopify.formatMoney
                ? Shopify.formatMoney(subCents != null ? subCents : this.variant.selling_plan_allocations[0].price)
                : "€" + subPrice.toFixed(2);
            })();
          const oneTimePriceFormatted = useSubscriptionPrice &&
            (() => {
              const p = this.variant.price / 100;
              return typeof Shopify !== "undefined" && Shopify.formatMoney
                ? Shopify.formatMoney(this.variant.price)
                : "€" + p.toFixed(2);
            })();
          const subscriptionCompareAtFormatted = useSubscriptionPrice &&
            (() => {
              const compareCents = (this.variant.compare_at_price && this.variant.compare_at_price > 0)
                ? this.variant.compare_at_price
                : this.variant.price;
              return typeof Shopify !== "undefined" && Shopify.formatMoney
                ? Shopify.formatMoney(compareCents)
                : "€" + (compareCents / 100).toFixed(2);
            })();

          if (priceCurrentEl) {
            priceCurrentEl.innerHTML = useSubscriptionPrice
              ? subscriptionPriceFormatted
              : this.data.formatted[this.variant.id].price;
            priceCurrentEl.dataset.variantId = this.variant.id;
          }
          if (priceWasEl) {
            priceWasEl.innerHTML = useSubscriptionPrice
              ? subscriptionCompareAtFormatted
              : (this.data.formatted[this.variant.id].compareAtPrice || "");
            priceWasEl.dataset.variantId = this.variant.id;
          }

          if (this.variant.unit_price_measurement) {
            const valueEl = price.querySelector(".unit-price__price");
            const unitEl = price.querySelector(".unit-price__unit");
            const value = this.variant.unit_price_measurement.reference_value;
            const unit = this.variant.unit_price_measurement.reference_unit;

            if (valueEl) valueEl.innerHTML = this.data.formatted[this.variant.id].unitPrice;
            if (unitEl) unitEl.textContent = value === 1 ? unit : `${value} ${unit}`;
          }

          if (unitPriceEl) unitPriceEl.hidden = !this.variant.unit_price_measurement;
          price.classList.toggle(
            "price--on-sale",
            useSubscriptionPrice || this.variant.compare_at_price > this.variant.price
          );

          price.classList.toggle("price--sold-out", !this.variant.available);

          let divided_price = (this.section || document).querySelector(
            ".product-scale-pay"
          )?.dataset.divider;
          if (divided_price) {
            (this.section || document).querySelector(
              ".product-scale-pay strong"
            ).innerHTML =
              (this.variant.price / parseInt(divided_price) / 100).toFixed(2) +
              "€";
            (this.section || document).querySelector(
              ".product-scale-pay strong"
            ).dataset.priceMultiplier = 1 / divided_price;
          }

          let divided_price_vrac = this.section?.querySelector(
            ".product-form__divided-price"
          )?.dataset.divider;
          let divided_price_vrac_price = Number(divided_price_vrac);
          if (divided_price_vrac && this.section) {
            const priceForDivision = subscriptionActiveForMain
              ? (this.getSubscriptionDisplayPriceCents() ?? this.variant.price)
              : this.variant.price;
            const dividedPrice = Math.floor(
              priceForDivision / parseInt(divided_price_vrac_price)
            );
            const allDividedPriceElements = this.section.querySelectorAll(
              ".product-form__divided-price span span"
            );

            allDividedPriceElements.forEach((el) => {
              el.innerHTML = Shopify.formatMoney(
                dividedPrice,
                Shopify.money_format
              );
              el.dataset.priceMultiplier = 1 / divided_price_vrac_price;
              el.dataset.variantId = this.variant.id;
            });
          }
          if (this.section?.querySelector('[data-subscribe="true"]') && !isQuickAddDrawer) {
            const subDisplayCents = this.getSubscriptionDisplayPriceCents();
            const allocationPrice = this.variant.selling_plan_allocations?.[0]?.price;
            const subDisplayFormatted =
              subDisplayCents != null
                ? Shopify.formatMoney(subDisplayCents)
                : allocationPrice != null
                  ? Shopify.formatMoney(allocationPrice)
                  : Shopify.formatMoney(this.variant.price);
            this.section
              .querySelectorAll(
                '[data-subscribe="true"] .price__current--custom'
              )
              .forEach((elem) => {
                elem.innerHTML = subDisplayFormatted;
              });
            this.section
              .querySelectorAll('[data-subscribe="true"] .price__curent--offer')
              .forEach((elem) => {
                elem.innerHTML = subDisplayFormatted;
              });
            const subPriceWas = this.section.querySelector(
              '[data-subscribe="true"] .price__was'
            );
            if (subPriceWas) {
              subPriceWas.innerHTML =
                (this.variant.compare_at_price && this.variant.compare_at_price > 0)
                  ? Shopify.formatMoney(this.variant.compare_at_price)
                  : Shopify.formatMoney(this.variant.price);
            }
          }
        }

        const priceDefault = price.querySelector(".price__default");
        const priceNoVariant = price.querySelector(".price__no-variant");
        if (priceDefault) priceDefault.hidden = !this.variant;
        if (priceNoVariant) priceNoVariant.hidden = this.variant;

      });
    }

    /**
     * Updates the SKU.
     */
    updateSku() {
      this.sku = this.sku || this.section.querySelector(".product-sku__value");
      if (!this.sku) return;

      const skuAvailable = this.variant && this.variant.sku;
      this.sku.textContent = skuAvailable ? this.variant.sku : "";
      this.sku.parentNode.hidden = !skuAvailable;
    }

    /**
     * Updates the url with the selected variant id.
     * @param {object} evt - Event object.
     */
    updateUrl(evt) {
      if (!evt || evt.type !== "change" || this.dataset.updateUrl === "false")
        return;
      window.history.replaceState(
        {},
        "",
        `${this.dataset.url}?variant=${this.variant.id}`
      );
    }

    /**
     * Updates the value of the hidden [name="id"] form inputs.
     */
    updateVariantInput() {
      this.forms =
        this.forms ||
        this.section.querySelectorAll(
          ".js-product-form-main, .js-instalments-form"
        );

      this.forms.forEach((form) => {
        const input = form.querySelector('input[name="id"]');
        input.value = this.variant.id;
        input.dispatchEvent(new Event("change", { bubbles: true }));
      });
    }

    /**
     * Gets the selected option element from each selector.
     * @returns {Array}
     */
    getSelectedOptions() {
      const selectedOptions = [];

      this.optionSelectors.forEach((selector) => {
        if (selector.dataset.selectorType === "dropdown") {
          selectedOptions.push(
            selector.querySelector(".custom-select__btn").textContent.trim()
          );
        } else {
          selectedOptions.push(selector.querySelector("input:checked").value);
        }
      });

      return selectedOptions;
    }

    /**
     * Gets the product data.
     * @returns {?object}
     */
    getProductData() {
      const dataEl = this.querySelector('[type="application/json"]');
      return JSON.parse(dataEl.textContent);
    }
  }

  customElements.define("variant-picker", VariantPicker);
}
